var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAirplane = function SvgAirplane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DDD",
    d: "M18 0c9.941 0 18 8.059 18 18s-8.059 18-18 18S0 27.941 0 18 8.059 0 18 0",
    opacity: 0.503
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M9.25 9.25h17.5v17.5H9.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24.927 20.917v-1.459l-5.833-3.646v-4.01a1.093 1.093 0 1 0-2.188 0v4.01l-5.833 3.646v1.459l5.833-1.823v4.01l-1.458 1.094v1.094l2.552-.73 2.552.73v-1.094l-1.458-1.094v-4.01z"
  }))));
};
export default SvgAirplane;